import { baseApi } from '@klp/core/api';
import { generateApiRoute } from '@klp/core/api/helpers';

import type { ByggKunderRequest, ByggKunderResponse } from './classes';
import { ByggKunde } from './classes/ByggKunde';
import type { IByggKunde } from './classes/ByggKunde';

const byggKundeApiName = 'bygg';

export const byggKunderApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getByggKunder: builder.query<ByggKunderResponse, ByggKunderRequest>({
            query: (requestParams) => ({
                url: generateApiRoute([
                    byggKundeApiName,
                    requestParams.byggNummer,
                    'kunder',
                ]),
            }),
            transformResponse: (
                response: Array<IByggKunde>,
            ): ByggKunderResponse => {
                const byggKunder = response.map((byggKunde: IByggKunde) =>
                    ByggKunde.parseObject(byggKunde),
                );
                return { byggKunder };
            },
            providesTags: (_result, _error, arg) => [
                { type: 'ByggKunder', id: arg.byggNummer },
            ],
        }),
    }),
});

export const { useGetByggKunderQuery, useLazyGetByggKunderQuery } =
    byggKunderApi;
